import { useEffect, type FC, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Dropdown } from 'shared/ui'
import { type OrdersStore } from 'features/DropdownOrder'
import { OrdersAction, OrdersItems } from 'features/DropdownOrder/actions/Orders'

type IDropdownOrderProps = {
  store: OrdersStore
}

export const DropdownOrder: FC<IDropdownOrderProps> = observer(({ store }) => {
  const [toggle, setToggle] = useState(false)
  const { loadOrders, orders, loading, order, reset } = store

  useEffect(() => {
    loadOrders()

    return () => {
      reset()
    }
  }, [])

  return (
    <Dropdown
      ariaLabel={'DropdownOrder'}
      icon={'chatLayout'}
      placement={'bottom-start'}
      typeButton={'button'}
      tooltipProps={{
        label: 'Chat view',
        placement: 'bottom',
      }}
      items={[...OrdersItems(orders, store)]}
      onChange={(item) => {
        OrdersAction(item, store)
      }}
      buttonProps={{
        text: order?.label,
        isRight: true,
        icon: toggle ? 'chevronUp' : 'chevronDown',
        typeBtn: 'text',
        contained: 'secondary',
        size: 'medium',
      }}
      onToggle={(status) => {
        setToggle(status)
      }}
      disabled={loading}
    />
  )
})
